/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditFilter {
    getFixupPrototypeFunction() { return RequestAuditFilter.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditFilter>): RequestAuditFilter {
        let obj = Object.assign(new RequestAuditFilter(), model);
        RequestAuditFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditFilter>): RequestAuditFilter {
        if (!model) return null;
        return RequestAuditFilter.newInstance(<RequestAuditFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditFilter) {
        if (!obj) return;

        models.RequestAuditFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditFilter): boolean {
        Object.setPrototypeOf(obj, RequestAuditFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.status_code === undefined) {
            this.status_code = 0;
        }
        if (this.duration === undefined) {
            this.duration = 0;
        }
        if (typeof this.active_after === "string") {
            this.active_after = new Date(<string><any>this.active_after);
        }
        if (typeof this.active_before === "string") {
            this.active_before = new Date(<string><any>this.active_before);
        }
    }

    /**
     * Limit results to requests from this executor
     */
    executor: models.BackgroundJobExecutor;

    /**
     * Limit results to requests to this endpoint
     */
    endpoint: string;

    /**
     * Limit results to requests to this status code
     */
    status_code: number;

    /**
     * Limit results to requests to this method
     */
    method: string;

    /**
     * Limit results to requests to this path
     */
    path: string;

    /**
     * Limit results to requests to this Correlation ID
     */
    request_id: string;

    /**
     * Limit to requests active after this time
     */
    active_after: Date;

    /**
     * Limit to requests active before this time
     */
    active_before: Date;

    /**
     * Limit to requests that took longer than this amount (it requires an activation range as well)
     */
    duration: number;

    /**
     * Limit to requests that have a profile trace
     */
    only_with_profile: boolean;

}
